module.exports = __webpack_public_path__ + "resources/img/bg_cover_marketplace_m_v3.14fa5995127957a689dd6074584088d4.png";